import ApiService from '../../components/api_services/apiService.jsx';
import { toggleCheckedItem } from '../../store/notificationsTabSlice';
import RowActions from '../../components/list2/RowActions';
import { setViewedNotification, toggleEditModal } from '../../store/notificationsTabSlice';

// Helper function to format date
const formatDate = (dateString) => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    return date.toLocaleString('pl-PL', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch (e) {
    return dateString;
  }
};

// Helper function to format date only (YYYY-MM-DD)
const formatDateOnly = (dateString) => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  } catch (e) {
    return dateString;
  }
};

export const fetchNotifications = async (
  sortBy,
  sortDirection,
  currentPage,
  dispatch,
  setMaxPages,
  setRows,
  setTotalCount,
  setNotificationsData,
  checkedItems,
  searchQuery,
  status,
  type,
  dateFrom,
  dateTo,
  isRecurring
) => {
  try {
    // Build query parameters for campaigns
    // Map sortBy to API format - API expects "createdAt" not "created_at"
    // API also supports "targetUserCount" for sorting by target user count
    let apiSortBy = sortBy;
    if (sortBy === 'createdAt') {
      apiSortBy = 'createdAt';
    } else if (sortBy === 'targetUserCount') {
      apiSortBy = 'targetUserCount'; // API expects camelCase
    }
    
    const params = {
      page_number: currentPage + 1, // API uses 1-based pagination
      page_size: 20,
      ...(apiSortBy && sortDirection && { sort_by: apiSortBy, sort_direction: sortDirection }),
      ...(searchQuery && { search_query: searchQuery }),
      ...(status && { status }), // ACTIVE or DELETED
      ...(type && { type }),
      ...(dateFrom && { date_from: formatDateOnly(dateFrom) }),
      ...(dateTo && { date_to: formatDateOnly(dateTo) }),
      ...(isRecurring !== null && { is_recurring: isRecurring }),
    };

    const response = await ApiService.getNotifications(params);

    const campaigns = response.data || [];
    const totalCount = response.total_count || 0;
    const maxPage = response.max_page || 1;

    dispatch(setMaxPages(maxPage));
    dispatch(setTotalCount(totalCount));

    // Store campaign data for select all functionality
    if (setNotificationsData) {
      setNotificationsData(campaigns);
    }

    // Map campaigns to table rows
    const mappedRows = campaigns.map((campaign) => {
      const isChecked = checkedItems.includes(campaign.id);

      return [
        <input
          key={`checkbox-${campaign.id}`}
          type="checkbox"
          checked={isChecked}
          onChange={() => {
            dispatch(toggleCheckedItem(campaign.id));
          }}
        />,
        campaign.title || '',
        campaign.message || '',
        campaign.send_to_all_users 
          ? 'Wszyscy użytkownicy' 
          : `${campaign.target_user_count || 0} użytkowników`,
        campaign.total_notifications || 0,
        campaign.firebase_sent_count || 0,
        campaign.rabbitmq_sent_count || 0,
        formatDate(campaign.created_at),
        <span
          key={`status-${campaign.id}`}
          className={`notification-status notification-status-${campaign.status?.toLowerCase()}`}
        >
          {campaign.status || 'ACTIVE'}
        </span>,
        <span
          key={`type-${campaign.id}`}
          className={`notification-type notification-type-${campaign.type?.toLowerCase()}`}
        >
          {campaign.type || 'SINGULAR'}
        </span>,
        <RowActions
          key={`actions-${campaign.id}`}
          onEdit={() => {
            dispatch(setViewedNotification(campaign.id));
            dispatch(toggleEditModal());
          }}
          onDelete={async () => {
            if (window.confirm('Czy na pewno chcesz usunąć tę kampanię?')) {
              try {
                await ApiService.deleteNotification(campaign.id);
                alert('Kampania została usunięta.');
                window.location.reload();
              } catch (error) {
                console.error('Błąd podczas usuwania kampanii:', error);
                alert('Nie udało się usunąć kampanii.');
              }
            }
          }}
        />,
      ];
    });

    setRows(mappedRows);
  } catch (error) {
    console.error('Błąd podczas pobierania kampanii:', error);
    setRows([]);
  }
};
